import { BottomNavigation, BottomNavigationAction, type Theme, type SxProps, Tooltip, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router'
import { is_history_enabled } from '../../utils/config'

const nav_action_sx: SxProps<Theme> = {
  padding: '0'
}
const nav_action_label_style = {
  fontSize: '10px'
}

const GlobalFooter: React.FC = () => {
  const {t} = useTranslation()
  const location = useLocation()
  const isNow = (path: string) => path === location.pathname
  const isNowIcon = (path: string) =>
    isNow(path) ? 'material-icons' : 'material-icons-outlined'

  return <Box
    component='footer'
  >
    <BottomNavigation
      showLabels
      sx={{
        position: 'relative',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
      }}
    >
      {FEATURE_HOME ? (
        <BottomNavigationAction
          sx={nav_action_sx}
          label={<span style={nav_action_label_style}>{t('feature.home')}</span>}
          icon={<span className={isNowIcon('/')}>home</span>}
          component={Link} to='/'
        />
      ) : (
        <Tooltip title={t('general.wip')} placement='top' enterTouchDelay={0} arrow>
          <BottomNavigationAction
            sx={nav_action_sx}
            label={<span style={{...nav_action_label_style, color: 'gray'}}>{t('feature.home')}</span>}
            icon={<span className={isNowIcon('/')} style={{color: 'gray'}}>home</span>}
          />
        </Tooltip>
      )}
      {is_history_enabled ? (
        <BottomNavigationAction
          sx={nav_action_sx}
          label={<span style={nav_action_label_style}>{t('history.title')}</span>}
          icon={<span className={isNowIcon('/history/worlds')}>history</span>}
          component={Link} to='/history/worlds'
        />
      ) : FEATURE_DM ? (
        <BottomNavigationAction
          sx={nav_action_sx}
          label={<span style={nav_action_label_style}>{t('feature.dm')}</span>}
          icon={<span className={isNowIcon('/dm')}>mail</span>}
          component={Link} to='/dm'
        />
      ) : (
        <Tooltip title={t('general.wip')} placement='top' enterTouchDelay={0} arrow>
          <BottomNavigationAction
            sx={nav_action_sx}
            label={<span style={{...nav_action_label_style, color: 'gray'}}>{t('feature.dm')}</span>}
            icon={<span className={isNowIcon('/dm')} style={{color: 'gray'}}>mail</span>}
          />
        </Tooltip>
      )}
      <BottomNavigationAction
        sx={nav_action_sx}
        label={<span style={nav_action_label_style}>{t('feature.my_photo')}</span>}
        icon={<span className={isNowIcon('/photo')}>photo</span>}
        component={Link} to='/photo'
      />
      {FEATURE_ALBUM && <BottomNavigationAction
        sx={nav_action_sx}
        label={<span style={nav_action_label_style}>
          {t('feature.my_album')}
        </span>}
        icon={<span className={isNowIcon('/album')}>folder</span>}
        component={Link} to='/album'
      />}
      {FEATURE_SHARE && <BottomNavigationAction
        sx={nav_action_sx}
        label={<span style={nav_action_label_style}>{t('feature.share_album')}</span>}
        icon={<span className={isNowIcon('/share')}>folder_shared</span>}
        component={Link} to='/share'
      />}
    </BottomNavigation>
  </Box>
}

export default GlobalFooter